import { APP_INITIALIZER, Provider, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

import iconsFull from '../../../utils/constants/layout/icons.json';
import iconsExtra from '../../../utils/constants/layout/_icons.json';

type IconEntry = { icon: string; path: string };

function toArray(obj: any, key: string): IconEntry[] {
  const arr = obj?.[key];
  return Array.isArray(arr) ? (arr as IconEntry[]) : [];
}

function buildIconMap(): Record<string, string> {
  const merged: IconEntry[] = [
    ...toArray(iconsFull, 'icons'),
    ...toArray(iconsFull, 'icons_menor'),
    ...toArray(iconsFull, 'feedback'),
    ...toArray(iconsFull, 'loading'),
    ...toArray(iconsExtra, 'icons')
  ];
  const map: Record<string, string> = {};
  for (const entry of merged) {
    if (entry?.icon && entry?.path) {
      map[entry.icon] = entry.path;
    }
  }
  return map;
}

export function provideIcons(): Provider[] {
  const iconMap = buildIconMap();
  return [
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: () => {
        const registry = inject(MatIconRegistry);
        const sanitizer = inject(DomSanitizer);
        return () => {
          registry.addSvgIconResolver((name, namespace) => {
            if (namespace === 'icons') {
              const relPath = iconMap[name];
              if (relPath) {
                return sanitizer.bypassSecurityTrustResourceUrl(`assets/icons/${relPath}`);
              }
            }
            return null;
          });
        };
      }
    }
  ];
}

export function iconUrl(name: string): string | null {
  const map = buildIconMap();
  return map[name] ? `assets/icons/${map[name]}` : null;
}


